export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5052.3148b114.jpg";